import { Component, ElementRef, EventEmitter, Injectable, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { ContactService } from 'api-services/contact.service'
import { SharedService } from 'services';
import { State } from '../../../../models/state.model';
import { LinesOfAuthorityService } from 'api-services/lines-of-authority.service';

@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date
      ? date.month + this.DELIMITER + date.day + this.DELIMITER + date.year
      : '';
  }
}

@Component({
  selector: 'app-new-manual-license',
  templateUrl: './new-manual-license.component.html',
  styleUrls: ['./new-manual-license.component.css'],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ]
})
export class NewManualLicenseComponent implements OnInit {

isLicenseCreatedSuccessfully: boolean = false;
  isCustomDateSelected: boolean;
  selectedCustomDate: Date;
  newManualLicenseForm: FormGroup;
  @ViewChild('customDatePicker') customDatePickerEle: ElementRef;
  date = new Date();
  autoDeleteDate = []
  @Input() isEditable;
  @Input() selectedAppId;
  @Output() onCancel = new EventEmitter<void>();
  userId: number;
  userDetail: any;
  residentState: State;
  masterStates: State[] = [] as State[];
  licenseLOATypeList = [
    {licenseLOATypeId : 1 , licenseLOAName : '00555 Services'},
    {licenseLOATypeId : 2 , licenseLOAName : '14055 Manage Services'}
  ];
  licenseTypeList = [
    {licenseTypeId : 1 , licenseName : 'Renewal Services'},
    {licenseTypeId : 2 , licenseName : 'Manage Services'}
  ];
  errorMessages = [];
  customAutoDeleteDate: any;
  autoDeletedays: number = 0;
  // maxDate: NgbDateStruct;
  minDateAutoDelete: NgbDateStruct;
  feinMask: any[] = [/\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  constructor(private router: Router, private contactService: ContactService, private sharedService: SharedService
    ,private loaService: LinesOfAuthorityService
  ) 
  { 
    if (localStorage.getItem('activeLicenseContactUserId') != null && localStorage.getItem('activeLicenseContactUserId').toString() != "") {
      this.userId = Number(localStorage.getItem("activeLicenseContactUserId"));
    }
  }

  ngOnInit(): void {

    this.loadMasterStates();
    
    this.autoDeleteDate = [
      {
      key: moment(this.date.setDate(this.date.getDate() + 7)).format('yyyy/MM/DD'),
      value: "In 7 Days " + "(" + moment(this.date.setDate(this.date.getDate())).format('MM/DD/yyyy') + ")"
      },
      {
        key: moment(this.date.setDate(this.date.getDate() + 7)).format('yyyy/MM/DD'),
        value: "In 14 Days " + "(" + moment(this.date.setDate(this.date.getDate())).format('MM/DD/yyyy') + ")"
      }
    ]

    this.newManualLicenseForm = this.bindnewManualLicenseForm();

    if(this.selectedAppId){
      // this.getAppointmentDetails();
    }else{
      this.getUser();
      this.getResidenceState();
    }
  }

  getUser()
  {
    this.contactService.getUser(this.userId).subscribe((response: any) => {
      this.userDetail = response;
    },
    (error: any) => {
      console.log(error);
    })
  }

  getResidenceState(){
    return new Promise((resolve) => {
      this.contactService.getResidenceStateOfUser(this.userId, this.sharedService.getValue("tenantId")).subscribe(
        (response: any) => {
          this.residentState = response;
        },
        (error: any) => {
          console.log(error);
        }
      );
    });
  }

  loadMasterStates() {
    this.loaService.getAllStates().subscribe(
      response => {
        this.masterStates = response;
      },
      error => {
        
      }
    )
  }

  bindnewManualLicenseForm(): FormGroup{
    return new FormGroup({
      stateId: new FormControl(null,[Validators.required]),
      licenseTypeId: new FormControl(null,[Validators.required]),
      tenantId: new FormControl(JSON.parse(localStorage['tenantId'])),
      userById: new FormControl(JSON.parse(localStorage['userId'])),
      licenseLOATypeId: new FormControl(null,[Validators.required]),
      status: new FormControl(null,[Validators.required]),
      issueDate: new FormControl(null,[Validators.required]),
      expirationDate: new FormControl(null,[Validators.required]),
      isAutoDelete: new FormControl(),
      autoDeleteDate: new FormControl(),
      writingCode: new FormControl(),
      licenseNumber: new FormControl(),
    })
  }

  clearDate(clearControl) {
    this.newManualLicenseForm.get(clearControl)!.setValue(null);
    this.newManualLicenseForm.markAsDirty();
  }

  onDateSelectionChange(event) {
    if(event === 'customDate') {
      this.customDatePickerEle.nativeElement.click();
    }else{
      this.getAutoDeleteDays(event);
    }
  }

  setCustomDate(event){
    const { year, month, day } = event;
    this.selectedCustomDate = new Date(year, month - 1, day);
    this.date = new Date();

    this.autoDeleteDate = [
      {
        key: moment(this.date.setDate(this.date.getDate() + 7)).format('yyyy/MM/DD'),
        value: "In 7 Days " + "(" + moment(this.date.setDate(this.date.getDate())).format('MM/DD/yyyy') + ")"
      },
      {
        key: moment(this.date.setDate(this.date.getDate() + 7)).format('yyyy/MM/DD'),
        value: "In 14 Days " + "(" + moment(this.date.setDate(this.date.getDate())).format('MM/DD/yyyy') + ")"
      },
      {
        key: moment(this.selectedCustomDate).format('YYYY/MM/DD'),
        value: moment(this.selectedCustomDate).format('MM/DD/YYYY')
      }
    ]
    this.newManualLicenseForm.get('autoDeleteDate')!.setValue(this.autoDeleteDate[2].value);
    this.getAutoDeleteDays(this.newManualLicenseForm.value.autoDeleteDate);    
  }

  getAutoDeleteDays(event){
    let currentDate = new Date();
    let deletedDate = new Date(event);

    this.autoDeletedays = Math.ceil((deletedDate.getTime() - currentDate.getTime()) / 1000 / 60 / 60 / 24);
  }

  backToAgentsPage() {
    this.router.navigate(['contact-list'])
  }

  backToLicensePage() {
    this.router.navigate(['main-licenses'])
  }

  close(event) {
    this.onCancel.emit(event);
  }

  formatToDate(date)
  {
    return date.year.toString() + '/' + date.month.toString() + '/' + date.day.toString()
  }

  convertDateFormat(date){
    if(date){
      var fetchedDate = new Date(date);
      return {
        year: fetchedDate.getFullYear(),
        month: fetchedDate.getMonth() + 1,
        day: fetchedDate.getDate()
      };
    }else{
      return null;
    }
  }

  resetautoDeleteDate(event){
    if(this.newManualLicenseForm.value.isAutoDelete){
      this.newManualLicenseForm.get("autoDeleteDate").setValidators([Validators.required]);
      this.clearDate('autoDeleteDate');
      this.getAutoDeleteDays(this.newManualLicenseForm.value.autoDeleteDate);
    }else{
      this.newManualLicenseForm.get("autoDeleteDate").clearValidators();
      this.clearDate('autoDeleteDate');
    }
    
  }

  createManualLicense() {
    localStorage.setItem("activeLicenseContactUserId", this.userId.toString());
    this.router.navigate(["/contact-list/manual-license"]);
  }

  addLicense(){
    this.isLicenseCreatedSuccessfully = true;
  }

}
